export const COURSE_REQUEST = `@@CourseReducer/COURSE_REQUEST`;
export const COURSE_SUCCESS = `@@CourseReducer/COURSE_SUCCESS`;
export const COURSE_FAIL = `@@CourseReducer/COURSE_FAIL`;

//DANH MUC KHOA HOC
export const COURSE_CATE_REQUEST = `@@CourseCateReducer/COURSE_CATE_REQUEST`;
export const COURSE_CATE_SUCCESS = `@@CourseCateReducer/COURSE_CATE_SUCCESS`;
export const COURSE_CATE_FAIL = `@@CourseCateReducer/COURSE_CATE_FAIL`;

//KHOA HOC THEO DANH MUC
export const GET_COURSE_WITH_CATEGORY_REQUEST = `@@CourseWithCateReducer/GET_COURSE_WITH_CATEGORY_REQUEST`;
export const GET_COURSE_WITH_CATEGORY_SUCCESS = `@@CourseWithCateReducer/GET_COURSE_WITH_CATEGORY_SUCCESS`;
export const GET_COURSE_WITH_CATEGORY_FAIL = `@@CourseWithCateReducer/GET_COURSE_WITH_CATEGORY_FAIL`;

//LAY CHI TIET KHOA HOC
export const GET_COURSE_DETAIL_REQUEST = `@@CourseDetailReducer/GET_COURSE_DETAIL_REQUEST`;
export const GET_COURSE_DETAIL_SUCCESS = `@@CourseDetailReducer/GET_COURSE_DETAIL_SUCCESS`;
export const GET_COURSE_DETAIL_FAIL = `@@CourseDetailReducer/GET_COURSE_DETAIL_FAIL`;
//DANG KY KHOA HOC
export const REGISTER_COURSE_REQUEST ="@@RegisterCourseReducer/REGISTER_COURSE_REQUEST";
export const REGISTER_COURSE_SUCCESS ="@@RegisterCourseReducer/REGISTER_COURSE_SUCCESS";
export const REGISTER_COURSE_FAIL ="@@RegisterCourseReducer/REGISTER_COURSE_FAIL";

//REGISTER FORM
export const REGISTER_REQUEST = `@@RegisterReducer/REGISTER_REQUEST`;
export const REGISTER_SUCCESS = `@@RegisterReducer/REGISTER_SUCCESS`;
export const REGISTER_FAIL = `@@RegisterReducer/REGISTER_FAIL`;
//USER DETAIL
export const GET_USER_DETAIL_REQUEST = `@@UserReducer/GET_USER_DETAIL_REQUEST`;
export const GET_USER_DETAIL_SUCCESS = `@@UserReducer/GET_USER_DETAIL_SUCCESS`;
export const GET_USER_DETAIL_FAIL = `@@UserReducer/GET_USER_DETAIL_FAIL`;
//USER LOGIN
export const USER_LOGIN_REQUEST = `@@UserLoginReducer/USER_LOGIN_REQUEST`;
export const USER_LOGIN_SUCCESS = `@@UserLoginReducer/USER_LOGIN_SUCCESS`;
export const USER_LOGIN_FAIL = `@@UserLoginReducer/USER_LOGIN_FAIL`;
export const USER_LOGIN_CLEAN = `@@UserLoginReducer/USER_LOGIN_CLEAN`;

//CANCEL COURSE 
export const CANCEL_COURSE_REQUEST = `@@CancelCourseReducer/CANCEL_COURSE_REQUEST`;
export const CANCEL_COURSE_SUCCESS = `@@CancelCourseReducer/CANCEL_COURSE_SUCCESS`;
export const CANCEL_COURSE_FAIL = `@@CancelCourseReducer/CANCEL_COURSE_FAIL`;
// UDATE USER
export const UPDATE_USER_REQUEST = `@@UpdateUserReducer/UPDATE_USER_REQUEST`;
export const UPDATE_USER_SUCCESS = `@@UpdateUserReducer/UPDATE_USER_SUCCESS`;
export const UPDATE_USER_FAIL = `@@UpdateUserReducer/UPDATE_USER_FAIL`;

// -------------------------------------------------ADMIN PAGE -----------------------------------------------------
// GET LIST USER
export const GET_LIST_USER_REQUEST = "@@ListUserReducer/GET_LIST_USER_REQUEST";
export const GET_LIST_USER_SUCCESS = "@@ListUserReducer/GET_LIST_USER_SUCCESS";
export const GET_LIST_USER_FAIL = "@@ListUserReducer/GET_LIST_USER_FAIL";
// ADD USER -- ADMIN PAGE
export const ADD_USER_REQUEST = "@@AddUserReducer/ADD_USER_REQUEST";
export const ADD_USER_SUCCESS = "@@AddUserReducer/ADD_USER_SUCCESS";
export const ADD_USER_FAIL = "@@AddUserReducer/ADD_USER_FAIL";
// DELET USER -- ADMIN PAGE
export const DELETE_USER_REQUEST = "@@DeleteUserReducer/DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "@@DeleteUserReducer/DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "@@DeleteUserReducer/DELETE_USER_FAIL";
// ADD COURSE - ADMIN
export const ADD_COURSE_REQUEST = "@@AddCourseReducer/ADD_COURSE_REQUEST";
export const ADD_COURSE_SUCCESS = "@@AddCourseReducer/ADD_COURSE_SUCCESS";
export const ADD_COURSE_FAIL = "@@AddCourseReducer/ADD_COURSE_FAIL";
//DELETE COURSE - ADMIN
export const DELETE_COURSE_REQUEST ="@@DeleteCourseReducer/DELETE_COURSE_REQUEST";
export const DELETE_COURSE_SUCCESS ="@@DeleteCourseReducer/DELETE_COURSE_SUCCESS";
export const DELETE_COURSE_FAIL = "@@DeleteCourseReducer/DELETE_COURSE_FAIL";
//UPDATE COURSE - ADMIN
export const UPDATE_COURSE_REQUEST ="@@UpdateCourseReducer/UPDATE_COURSE_REQUEST";
export const UPDATE_COURSE_SUCCESS ="@@UpdateCourseReducer/UPDATE_COURSE_SUCCESS";
export const UPDATE_COURSE_FAIL = "@@UpdateCourseReducer/UPDATE_COURSE_FAIL";
//MODAL-COURSE CONFIRM -ADMIN
export const COURSES_CONFIRM_REQUEST ="@@CourseConfirmReducer/COURSES_CONFIRM_REQUEST";
export const COURSES_CONFIRM_SUCCESS ="@@CourseConfirmReducer/COURSES_CONFIRM_SUCCESS";
export const COURSES_CONFIRM_FAIL ="@@CourseConfirmReducer/COURSES_CONFIRM_FAIL";
// MODAL-COURSE UNREG -ADMIN
export const COURSES_UNREG_REQUEST ="@@CourseUnRegReducer/COURSES_UNREG_REQUEST";
export const COURSES_UNREG_SUCCESS ="@@CourseUnRegReducer/COURSES_UNREG_SUCCESS";
export const COURSES_UNREG_FAIL = "@@CourseUnRegReducer/COURSES_UNREG_FAIL";
//COURSE WAIT CONFIRM - ADMIN
export const COURSES_WAIT_CONFIRM_REQUEST ="CourseWaitConfirmReducer/COURSES_WAIT_CONFIRM_REQUEST";
export const COURSES_WAIT_CONFIRM_SUCCESS ="CourseWaitConfirmReducer/COURSES_WAIT_CONFIRM_SUCCESS";
export const COURSES_WAIT_CONFIRM_FAIL ="CourseWaitConfirmReducer/COURSES_WAIT_CONFIRM_FAIL";
//DELETE COURSE - ADMIN
export const DEL_COURSE_BY_ADMIN_REQUEST ="@@DelCourseByAdminReducer/DEL_COURSE_BY_ADMIN_REQUEST";
export const DEL_COURSE_BY_ADMIN_SUCCESS ="@@DelCourseByAdminReducer/DEL_COURSE_BY_ADMIN_SUCCESS";
export const DEL_COURSE_BY_ADMIN_FAIL ="@@DelCourseByAdminReducer/DEL_COURSE_BY_ADMIN_FAIL";
//REGISTER COURSE - ADMIN
export const REG_COURSE_BY_ADMIN_REQUEST ="@@RegCourseByAdminReducer/REG_COURSE_BY_ADMIN_REQUEST";
export const REG_COURSE_BY_ADMIN_SUCCESS ="@@RegCourseByAdminReducer/REG_COURSE_BY_ADMIN_SUCCESS";
export const REG_COURSE_BY_ADMIN_FAIL ="@@RegCourseByAdminReducer/REG_COURSE_BY_ADMIN_FAIL";

